import { ELEMENTI, RACCOLTE, SLUG, UTENTE } from 'utils/endpoint'
import { MEMBER, api, EMAIL_REDAZIONE } from 'utils'
import React, { useEffect, useState } from 'react'
import Actionbar from 'components/atomic/Actionbar'
import ArticoloCard from 'components/card/ArticoloCard'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import Grid from 'components/atomic/Grid'
import Icon from 'components/atomic/Icon'
import { IoplusBar } from 'components/atomic/Ioplus'
import LazyLoad from 'react-lazyload'
import Link from 'next/link'
import MetaSeo from 'components/atomic/MetaSeo'
import Pills from 'components/atomic/Pills'
import RaccoltaCard from 'components/card/RaccoltaCard'
import StrumentoCard from 'components/card/StrumentoCard'
import Switch from 'components/atomic/Switch'
import Tags from 'components/atomic/Tags'
import Trans from 'components/atomic/Trans'
import LezioneCard from 'components/card/LezioneCard'
import Slider from 'components/Slider'
import Masonry from 'components/atomic/Masonry'
import { setItem } from 'containers/toolbar'
import { useDispatch } from 'react-redux'

const RaccoltaDetail = React.memo(({ item, pagina, statusCode, risorse, elementi }) => {
  if (!item) return <Error statusCode={statusCode} />

  const [items, setItems] = useState([])
  const [masonry, setMasonry] = useState(true)
  const [raccolta, setRaccolta] = useState(item)
  const mainImage = raccolta.main_image
  const autore = raccolta.utenti.length ? raccolta.utenti[0] : null
  const isRedazionale = !autore || (autore && autore.redazionale)

  const dispatch = useDispatch()
  const iconRedazionale = <Icon id="logosymbol" classes="icon--logosymbol" />

  let autoreIcona = null

  const refresh = async () => {
    const { data } = await api.get(`${RACCOLTE}${item.id}/`)
    setRaccolta(data)
    dispatch(setItem(data))
  }

  useEffect(() => {
    refresh()
  }, [])

  if (!autore || autore.email === EMAIL_REDAZIONE) {
    autoreIcona = (
      <span className="redazionale">
        <Icon id="logosymbol" classes="icon--logosymbol" /> Redazione GiuntiScuola
      </span>
    )
  } else if (autore.redazionale) {
    autoreIcona = (
      <Link legacyBehavior href={autore.url}>
        <a>
          <strong> {autore.titolo}</strong> {iconRedazionale}
        </a>
      </Link>
    )
  } else {
    autoreIcona = (
      <Link legacyBehavior href={autore.url}>
        <a>
          <strong> {autore.titolo}</strong> <Icon id="community" classes="icon--community" />
          <span className="from-community"> Dalla Community</span>
        </a>
      </Link>
    )
  }

  const renderCard = (item, horizontal = false) => {
    switch (item.model_class) {
      case 'strumento':
        return <StrumentoCard strumento={item} horizontal={horizontal} />
      case 'articolo':
        return <ArticoloCard articolo={item} horizontal={horizontal} />
      case 'lezione':
        return <LezioneCard articolo={item} horizontal={horizontal} />
      default:
        return <RaccoltaCard raccolta={item} horizontal={horizontal} />
    }
  }

  const checkTools = (list, masonry) => {
    const params = list.map(({ id, model }) => ({
      content_type_id: model,
      object_id: id,
    }))

    let items = []

    api.get(UTENTE + 'tools/', { params }).then((response) => {
      if (masonry) {
        items = list.map((item) => {
          const current = response.data.find(
            (e) => e.content_type_id === item.model && e.object_id === item.id
          )

          const { saved, following, file_url, pdf_file } = current

          const enhanced = {
            extra: { ...item.extra, file_url, pdf_file },
            saved,
            following,
            ...item,
          }

          return (
            <div className="masonry__item" key={item.id}>
              {renderCard(enhanced, false)}
            </div>
          )
        })
      } else {
        items = list.map((item) => {
          const current = response.data.find(
            (e) => e.content_type_id === item.model && e.object_id === item.id
          )

          const { saved, following, file_url, pdf_file } = current

          const enhanced = {
            extra: { ...item.extra, file_url, pdf_file },
            saved,
            following,
            ...item,
          }

          return (
            <div className="col col-sm-6 grid__item" key={item.id}>
              {renderCard(enhanced, true)}
            </div>
          )
        })
      }

      setItems(items)
    })
  }

  const initializeItems = (elementi, masonry) => {
    if (elementi.length) {
      const list = elementi.filter((e) => e.elemento !== null).map((e) => e.elemento) // tolgo un livello

      if (list.length) {
        let items = []
        let horizontal = false

        if (masonry) {
          items = list.map((item) => (
            <div className="masonry__item" key={item.id}>
              {renderCard(item, horizontal)}
            </div>
          ))
        } else {
          horizontal = true

          items = list.map((item) => (
            <div className="col col-sm-6 grid__item" key={item.id}>
              {renderCard(item, horizontal)}
            </div>
          ))
        }

        setItems(items)

        checkTools(list, masonry)
      }
    }
  }

  useEffect(() => {
    initializeItems(elementi, masonry)
  }, [masonry, elementi])

  return (
    <>
      {raccolta ? (
        <>
          <MetaSeo seo={pagina.seo} />

          <main className="raccolta-page">
            <header className="raccolta-page__header">
              <div className="w-container">
                <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
              </div>

              <div className="w-container-inner">
                <div className="row">
                  <div className={`col-md-8 ${isRedazionale ? 'order-md-2' : 'offset-md-2'}`}>
                    <div className="raccolta-page__header__summary">
                      {raccolta.membership == MEMBER ? <IoplusBar /> : null}

                      <p className="intro">
                        <Trans chiave="raccolta-page-header-summary-intro Raccolta" />
                      </p>
                      <h1 className="title">{raccolta.titolo}</h1>

                      <Tags tassonomia={raccolta.tassonomia} />

                      <p className="author">di {autoreIcona}</p>
                      <p className="abstract">{raccolta.descrizione}</p>
                      {/* <p className="date">{raccolta.data_pubblicazione}</p> */}
                    </div>
                  </div>
                  {isRedazionale && mainImage ? (
                    <div className="col-md-4 order-md-1">
                      <div className="raccolta-page__header__image-box">
                        <LazyLoad height={370} offset={100} once>
                          <img
                            src={mainImage}
                            alt={raccolta.titolo?.toAltTitle()}
                            title={raccolta.titolo?.toAltTitle()}
                          />
                        </LazyLoad>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </header>

            <div className="w-container">
              {items.length ? (
                <div className="elements">
                  <Switch isChecked={masonry} handleToggle={() => setMasonry(!masonry)} />
                  {masonry ? <Masonry items={items} /> : <Grid items={items} />}
                </div>
              ) : null}

              <Pills tassonomia={raccolta.tassonomia} />
            </div>

            <Actionbar item={raccolta} save />

            {risorse.length ? (
              <Slider items={risorse} classes="" titolo="Raccolte consigliate" />
            ) : null}
          </main>
        </>
      ) : null}
    </>
  )
})

export const getServerSideProps = async ({ query: { slug }, res, req }) => {
  const headers = req?.headers?.cookie
    ? { cookie: req.headers.cookie, anteprima: req.headers.anteprima || false }
    : undefined

  try {
    const response = await api.get(`${RACCOLTE}${SLUG}${slug}/`, { headers })
    const item = response.data

    const pagina = item.pagina

    const toolbarProps = { toolbarPage: pagina, toolbarItem: item }

    const risorseResponse = await api.get(`${RACCOLTE}${item.id}/risorse_correlate/`, {
      params: { excluded: 'articolo/lezione/strumento' },
      headers: headers,
    })
    const risorse = risorseResponse.data.results
    const elementiResponse = await api.get(`${ELEMENTI}${item.id}`)
    const elementi = elementiResponse.data

    return { props: { item, pagina, key: item.id, ...toolbarProps, risorse, elementi } }
  } catch (error) {
    if (res) {
      res.statusCode = 404
    }
    return { props: { statusCode: 404 } }
  }
}

export default RaccoltaDetail
